import { createAsyncThunk } from '@reduxjs/toolkit';
import { privateApiConnections, set, unset } from './apiConnections';

export const register = createAsyncThunk(
  '/auth/register',
  async (credentials, thunkAPI) => {
    try {
      const { data } = await privateApiConnections.post(
        '/users/signup',
        credentials,
      );
      // Запись token для всех последующих операций
      set(data.token);
      // Сохраняем токен в localStorage
      localStorage.setItem('token', data.token);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.massage);
    }
  },
);

export const logIn = createAsyncThunk(
  '/auth/login',
  async (credentials, thunkAPI) => {
    try {
      const { data } = await privateApiConnections.post(
        '/users/login',
        credentials,
      );
      // Запись token для всех последующих операций
      set(data.token);
      // Сохраняем токен в localStorage
      localStorage.setItem('token', data.token);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.massage);
    }
  },
);

export const logOut = createAsyncThunk('/auth/logout', async (__, thunkAPI) => {
  try {
    await privateApiConnections.post('/users/logout');
    // Очищаем token после logOut
    unset();
    // Удаляем токен из localStorage
    localStorage.removeItem('token');
  } catch (error) {
    return thunkAPI.rejectWithValue(error.massage);
  }
});

export const refreshCurrentUser = createAsyncThunk(
  'auth/refresh',
  async (__, thunkAPI) => {
    const state = thunkAPI.getState();
    const persistToken = state.auth.token;

    if (persistToken === null) {
      return thunkAPI.rejectWithValue();
    }

    set(persistToken);
    try {
      const { data } = await privateApiConnections.get('/users/current');
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.massage);
    }
  },
);
